import React, { Component} from 'react';
import { connect } from "react-redux";
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledTooltip, Card, CardBody, CardHeader } from "reactstrap";
import { NotificationManager } from "react-notifications";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import DataTable from "../../components/Table/Table";
import "react-table/react-table.css";
import { Link } from "react-router-dom";
import {getUrlFilterPolicies, deleteUrlFilterPolicy,setWebFilterPageInfo} from "../../actions/actionFilters"

class UrlFilter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            filterId: null,
        };

        this.cancelDelete = this.cancelDelete.bind(this);
        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.deleteFilterAction = this.deleteFilterAction.bind(this);
        this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
        this.handleDeleteError = this.handleDeleteError.bind(this);
    }

    componentDidMount() {
        this.props.getUrlFilterPolicies();
    }

    deleteConfirm(filterId){
        this.setState({modal: !this.state.modal,
            filterId: filterId});
    }

    cancelDelete(){
        this.setState({modal: !this.state.modal});
    }

    deleteFilterAction(){
        this.props.deleteUrlFilterPolicy(this.state.filterId).
        then(() => this.handleDeleteSuccess()).
        catch(() => this.handleDeleteError());
    }

    handleDeleteSuccess(){
        const {deleteFilterErrorMessage} = this.props;
        if(deleteFilterErrorMessage) {
            NotificationManager.error(deleteFilterErrorMessage,"Delete Web Filter Policy Failed", 3000);
        }else{
            NotificationManager.success("Successfully Deleted Web Filter Policy","Delete Web Filter Policy", 3000);
            this.setState({modal: false});
            this.props.getUrlFilterPolicies();
        }
    }

    handleDeleteError(){
        const {deleteFilterError} = this.props;
        if(deleteFilterError){
            NotificationManager.error(deleteFilterError,"Failed to Delete Web Filter Policy", 3000);
            this.props.history.push("/webfilter");
        }else{
            NotificationManager.error("Failed to Delete Web Filter Policy","Delete Web Filter Policy", 3000);
            this.props.history.push("/webfilter");
        }
    }

    render() {
        if (this.props.getFilterLoading) {
            return (<div> <LoadingSpinner /></div>);
        }

        const {filters} = this.props;

        const tableColumns = [
            {
                type: "text",
                name: "Name",
                accessor: "filter_policy_name",
                filterable: true,
                sortable: true,
            },
            {
                type: "text",
                name: "Description",
                accessor: "filter_policy_descriptions",
                filterable: true,
                sortable: true,
            },
            
        ];

        const actions = [
            { id: "view", icon: "fa-eye", description: "View" },
            { id: "edit", icon: "fa-pencil", description: "Edit" },
            { id: "delete", icon: "fa-trash", description: "Delete" },
        ];

        const onAction = (action, item) => {
            switch (action) {
                case "view":
                    this.props.history.push(`/viewfilter/${item.filter_policy_id}`);
                break;

                case "edit":
                    this.props.history.push(`/updatefilter/${item.filter_policy_id}`);
                break;

                case "delete":
                    this.deleteConfirm(item.filter_policy_id);
                break;
            }
        }

        return(
            <div className="profile-page">
                <Row>
                    <Col sm={{ size: 10, order: 3, offset: 1 }}>
                        <Card >
                            <CardHeader>
                            <div className="title-head">
                                <i className="fa fa-ban"></i> <strong>Web Filter Policies</strong> </div>
                                <Link className="pull-right add-btn" to={{ pathname: "/createfilter" }}>
                                    <button className="pull-right adduser-btn" size="sm" color="dark">
                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                        Add Policy
                                    </button>
                                </Link>
                            </CardHeader>
                            <CardBody className="p-0">
                                <DataTable
                                    id="webfilters"
                                    data={filters}
                                    columns={tableColumns}
                                    actions={actions}
                                    onAction={onAction}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Modal isOpen={this.state.modal} toggle={this.cancelDelete} centered={true} className="user-modal">
                    <ModalHeader toggle={this.cancelDelete}>Are you sure you want to delete this policy?
                    </ModalHeader>
                    <ModalFooter>
                        <Button onClick={this.cancelDelete} size="sm" 
                        className="cancel-button"
                        color=" basic">Close</Button>
                        <Button onClick={this.deleteFilterAction} size="sm"
                        className="delete-button"
                        color="danger"> Delete</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

}

export default connect(state => ({
        filters: state.filter.filters || [],
        categories: state.filter.categories || [],
        getFilterLoading: state.filter.getFilterLoading || false,
        getFilterErrorMessage: state.filter.getFilterErrorMessage || false,
        getFilterError: state.filter.getFilterError || null,
        deleteFilterErrorMessage: state.filter.deleteFilterErrorMessage || null,
        deleteFilterError: state.filter.deleteFilterError || null,
        deletedFilter: state.filter.deletedFilter || null,
        deleteFilterLoading: state.filter.deleteFilterLoading || null,
        pages : {pageSize : state.filter.pageSize, pageNo : state.filter.pageNo},
    }),
    dispatch => ({
        getUrlFilterPolicies: () => dispatch(getUrlFilterPolicies()),
        deleteUrlFilterPolicy: (data) => dispatch(deleteUrlFilterPolicy(data)),
       setPageInfo : (data)=> dispatch(setWebFilterPageInfo(data)),

    }))(UrlFilter);
